// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "categories__item-lS7ZM";
var _4 = "active-1psWN";
var _5 = "icon-2dq-0";
var _6 = "meal-1Po0s";
var _7 = "price-1O91t";
var _8 = "details__passenger-vxLTg";
var _9 = "details__clear-3eUKL";
var _a = "details__trigger-3dPga";
var _b = "details__addForAll-3AysC";
export { _1 as "__esModule", _2 as "mobile", _3 as "categories__item", _4 as "active", _5 as "icon", _6 as "meal", _7 as "price", _8 as "details__passenger", _9 as "details__clear", _a as "details__trigger", _b as "details__addForAll" }
export default { "__esModule": _1, "mobile": _2, "categories__item": _3, "active": _4, "icon": _5, "meal": _6, "price": _7, "details__passenger": _8, "details__clear": _9, "details__trigger": _a, "details__addForAll": _b }
